/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import Feather from '@strapi/icons/Feather';
const PluginIcon = () => /*#__PURE__*/React.createElement(Feather, null);
export default PluginIcon;